import tw, { styled } from 'twin.macro';
import Icon from '@/components/Icon/IconAsset';

export const StyledTotals = styled.div`
  ${tw`m-3`}
  ${tw`flex flex-col gap-2 sm:flex-row`}
  ${tw`md:*:first-of-type:border-r-2 *:first-of-type:border-ui-colours-ui3`}
  ${tw`md:*:px-5`}
  ${tw`text-body-xs md:text-body-s`}
  ${tw`font-poppins`}
`;

export const StyledTotal = styled.p`
  ${tw`text-mobile-body-l md:text-mobile-heading-s text-primary-p1`}
  ${tw`font-semi-bold`}
`;

export const StyledBarLabel = styled.text`
  ${tw`hidden sm:block`}
  ${tw`font-inter`}
  ${tw`text-[rgba(0, 0, 0, 0.7)]`}
  ${tw`text-body-xs`}
`;

export const StyledIcon = styled(Icon)`
  ${tw`hidden lg:block`}
  ${tw`w-[34px] h-[34px]`}
`;

export const StyledStatistic = styled.div`
  ${tw`flex gap-2`}
`;

export const StyledTitle = styled.h2`
  ${tw`md:text-mobile-heading-s font-semi-bold`}
  ${tw`mt-2 p-1`}
  justify-self: center;
`;
